module.exports = __webpack_public_path__ + "img/qysm.1ea3cf0b.png";